import { useCmsContent } from '@src/contexts/cms-content-context';

import { WarningIcon } from '../icons/warning';

import styles from './downtime-alert.module.css';

export const DowntimeAlert = () => {
  const content = useCmsContent();

  if (!content.downtimeAlertDisplayed) {
    return <></>;
  }

  return (
    <div className={styles.downtimeAlertContainer}>
      <div className={styles.downtimeAlert}>
        <WarningIcon />
        {content.downtimeDescription}
      </div>
    </div>
  );
};
